import { UserRoles } from '../../enums';
import { Options } from '../../../domain/useOptions';

export const USER_ROLE_OPTIONS: Options[] = [
  { label: 'Account owner', value: UserRoles.ACCOUNT_OWNER },
  { label: 'Account admin', value: UserRoles.ACCOUNT_ADMIN },
  { label: 'Team member', value: UserRoles.TEAM_MEMBER }
];
